import { PartialReloader } from './PartialReloader';

export class Reloader {
    constructor(
        private partialReloader: PartialReloader,
        private isCheckoutV2: boolean
    ) {}
    public async trigger() {
        if (this.isCheckoutV2) {
            await this.partialReloader.trigger();
        } else {
            /*                                                                                           */
            await window.o_order.basket?.presenter?.reloadBasket();
            /*                                                                                           */
            await window.o_order.checkout?.presenter?.reloadCheckout();
        }
    }
}
